export enum SamplingState {
    Submitted = "Submitted",
    Sampling = "Sampling",
    EditsRequired = "EditsRequired",
    Photos_InternalApproved = "Photos_InternalApproved",
    Photos_ClientApproved = "Photos_ClientApproved",
    Shipped = "Shipped",
    Physical_ClientApproved = "Physical_ClientApproved",
}
